import { AxiosError } from 'axios';
import { useState } from 'react';

import { VehicleCategoryInterface } from '../../../models/dashboard/driver-setup/vehicle-category';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import { vehicleCategoryActions } from '../../../redux/slices/vehicleCategorySlice';
import { useAppDisPatch } from '../../../redux/store';
import useHttps from '../../useHttps';

const useVehicleCategory = () => {
    const request = useHttps();
    const dispatch = useAppDisPatch();
    const [loading, setLoading] = useState(false);

    const onGetVehicleCategoryError = (err: AxiosError<ErrorHttpResponse>) => {
        console.error(err?.response?.data?.message ?? 'Something went wrong');
    };

    const onGetVehicleCategorySuccess = ({
        data,
        message,
    }: SuccessHttpResponse<VehicleCategoryInterface[]>) => {
        dispatch(vehicleCategoryActions.setVehicleCategoryData(data));
    };

    const getVehicleCategory = async () => {
        const url: HttpConfig = {
            url: `api/v1/company/vehicle-categories`,
            method: 'get',
        };

        return request(url, onGetVehicleCategorySuccess, setLoading, onGetVehicleCategoryError);
    };

    return { getVehicleCategory, loading };
};

export default useVehicleCategory;
